module.exports = __webpack_public_path__ + "static/media/intern_larga_retropie.38bfe2a2.png";